export const agent = {
  yqmh: "Convidar caixa surpresa",
  yqzmh: "Convite para ganhar caixas surpresa",
  bfbkj: "sorteio de 100%",
  yqpy: "Convidar amigos",
  pywczcrw: "Amigos se registram e completam tarefas",
  hdcmhcs: "Obtenha o número de sorteios de caixa cega",
  jllb: "Lista de recompensas",
  mhjlbk: "As recompensas da caixa cega podem incluir: {text} O valor específico está sujeito à recompensa real recebida!",
  kkcs: "Pode ser aberto {value} vezes",
  mhmx: "Detalhes da caixa cega",
  jpmx: "Detalhes do prêmio",
  hdmhs: "Número de caixas cegas obtidas",
  hyjd: "Progresso dos Amigos",
  jplx: "Tipo de prêmio",
  dbmc: "Nome do token",
  ypf: "Distribuído",
  wpf: "Não despachado",
  lq: "Receber",
  zblw: "Presentes Circundantes",
  gxczmh: "Parabéns por ganhar {amount}, convide novos amigos, conclua a tarefa e ganhe a caixa surpresa",
  lxkflq: "Entre em contato com o atendimento ao cliente para obter recompensas de presentes periféricos",
  shdz: "endereço de entrega",
  rwmc: "Nome da Tarefa",
  wczt: "Status de conclusão",
  hdmhsl: "Obtenha o número de caixas cegas",
  zblqdz: "Endereço de retirada próximo",
  shr: "Destinatário",
  dh: "telefone",
  xxdz: "Endereço detalhado",
  yqmhhdgz: "Regras da atividade de caixa surpresa de convite",
  yqyl: "1. O que é o presente de convite Biking?",
  yhhkxt: "O presente de convite Biking é um sistema de feedback dos usuários do Biking, que visa retribuir a todos os usuários leais que reconhecem o Biking e convidam amigos para participar do Biking.",
  yqhyhdfhjl: "O convite Biking é simples e fácil de usar. Os usuários só precisam convidar amigos para ganhar recompensas valiosas.",
  cyhdhqjl: "2. quais recompensas posso obter participando do evento e concluindo as tarefas?",
  hywcrwhdjl: "Quem convida convida amigos, e os amigos completam as tarefas correspondentes. Tanto quem convida quanto quem recebe o convite podem receber uma caixa surpresa e abri-la para receber recompensas.",
  mhhdgz: "3. Regras para obter caixas cegas",
  syrwczc: "1. O convidado conclui o registro e a verificação do nome real - o convidado tem uma chance de ativar a conta",
  syrcz: "2. O convidado deposita ≥ 100 USDT - o convidante e o convidado têm 1 chance cada para abrir a conta",
  syrcssxf: "3. A taxa de contrato do convidado é ≥30USDT - o convidante e o convidado ganham 2 oportunidades de abertura cada",
  qqjyl: "4. Volume de negociação de opções ≥ 200 USDT - o convidante e o convidado recebem 2 oportunidades de abertura cada",
  yxjyl: "5. Volume de transações da Gamefi ≥ 200 USDT e odds de ordens não inferiores a 1,2 vezes, ordens com odds inferiores a 1,2 vezes não serão contadas - o autor do convite e o convidado têm 2 oportunidades de abertura cada",
  xhmrjyl: "6. Volume de transação de compra à vista ≥ 500 USTD - o convidante e o convidado ganham 1 oportunidade de abertura cada",
  rwqbwc: "Se todas as tarefas de convite forem concluídas a cada vez, o autor do convite poderá ter até 8 oportunidades de abrir a caixa surpresa e, se todos os convidados concluírem as tarefas, eles poderão ter até 9 oportunidades de abrir a caixa surpresa. Convide várias pessoas e as chances de ganhar uma caixa surpresa aumentarão cumulativamente de acordo com as regras.",
  qtsm: "4. Outras instruções",
  mhffsj: "1. Horário de distribuição da caixa cega - atualize a cada 10 minutos",
  jlffsj: "2. Horário de distribuição de recompensas - o backend distribuirá recompensas uma vez por dia, ao meio-dia",
  syyhjkcj: "3. Todos os usuários podem participar e não há conflito com outras atividades",
  mhcjs: "4. O número de sorteios de caixas cegas será zerado no dia 1º de cada mês",
  yqmts: "Convide apenas usuários para se tornarem subordinados, e as transações subordinadas gerarão comissões para você",
  fym: "código de desconto",
  fymts: "Convide e abra diretamente uma taxa de desconto para usuários subordinados que não seja maior que a sua, e as transações subordinadas receberão comissões proporcionalmente",
  szfym: "Definir código de desconto",
  xzfym: "Adicionar novo código de desconto",
  lj: "Link",
  fybl: "Taxa de desconto",
  yyqhys: "Número de amigos convidados",
  sykcjs: "O restante pode ser criado",
  tjlx: "Tipo recomendado",
  bwjs: "5. Caso seja descoberto que qualquer indivíduo ou equipe se envolveu em benefícios de blind box, a CoinKing reserva-se o direito de deduzir ou cancelar a qualificação para o benefício da conta. Todos os usuários que participam deste benefício são considerados como tendo aceitado os termos oficiais do benefício, e a CoinKing Exchange reserva-se o direito de interpretação final.",
  swmr: "Definir como padrão",
  cffym: "O código de desconto está repetido, insira o código de desconto correto",
  qxtjfym: "Por favor, adicione o código de desconto primeiro",
  xywdbl: "10 <= minha taxa de desconto",
  qsrdybl: "Por favor, insira a proporção correspondente",
  qsrzqsl: "Por favor, insira um valor correto",
  qsrbz: "Por favor, insira observações",
  bnbhzf: "Não pode conter caracteres especiais ou emoticons",
  pfjj: "Distribuição rejeitada",
  pfsb: "Falha na distribuição de recompensas",
  lxkf: "Entre em contato com o atendimento ao cliente para obter mais detalhes",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/pt_BR.js